import {
  BorderProps,
  ButtonModalProps,
  ButtonProps,
  TextFieldProps,
  TextProps,
} from 'spindl-shared-components';

type SettingsSideBarInternalProps = {
  text?: TextProps;
  button?: ButtonProps;
  emailField?: TextFieldProps;
  senderNameField?: TextFieldProps;
  senderEmailField?: TextFieldProps;
  replyField?: TextFieldProps;
  border?: BorderProps;
  saveButton?: ButtonProps;
  discardButton?: ButtonProps;
  warningModal?: ButtonModalProps;
};

type SettingsSideBarPropsValues = {
  '': SettingsSideBarInternalProps;
};

const propValues: SettingsSideBarPropsValues = {
  '': {
    text: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading1',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Dark',
      state: 'Default',
    },
    emailField: {
      state: 'Default',
      type: 'Text',
      error: 'None',
    },
    senderNameField: {
      state: 'Default',
      type: 'TextRequired',
      error: 'None',
    },
    senderEmailField: {
      state: 'Default',
      type: 'TextRequired',
      error: 'None',
    },
    replyField: {
      state: 'Default',
      type: 'Text',
      error: 'None',
    },
    border: {
      colour: 'Subdued',
      type: 'Horizontal',
      styleType: 'Default',
    },
    saveButton: {
      type: 'Text',
      size: 'M',
      styleType: 'Primary',
      state: 'Default',
    },
    discardButton: {
      type: 'Text',
      size: 'M',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
};

const getProps = (type: string): SettingsSideBarInternalProps => {
  const values: SettingsSideBarInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
